module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_6005.0d6da7a9.png";